//import { useState } from 'react';
//import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './model.css';
//import { useNavigate } from 'react-router-dom';

function Model({ prop }) {
    const handleClose = () => prop.setShow(false);
   //const navigate = useNavigate()
 

    return (
        <>
            <Modal show={prop.show} onHide={handleClose} centered className='model modalContact'>
                <Modal.Header closeButton className="">
                <h5>{prop.content.header}</h5>
                  
                </Modal.Header>
                <Modal.Body>
                <div>
                    <img src={prop.content.icon} alt="Icon" width='40px' className="centered-img" />
                    <p className='text-center'>
                        {prop.content.body}
                    </p>
                    
                </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btnBlue' onClick={prop.content.handleSuccess}>{prop.content.button}</button>
                </Modal.Footer>
                
            </Modal>
        </>
    );
}

export default Model;
